import React, { createContext, useContext, useState } from 'react';

export const TitleContext = createContext<[string, (value: string) => void]>(['', () => {}]);

export const TitleProvider: React.FC = ({ children }) => {
  const [title, setTitle] = useState<string>('');
  return <TitleContext.Provider value={[title, setTitle]}>{children}</TitleContext.Provider>;
};

export const useTitle = () => useContext(TitleContext);
